interface IconProps {
  color?: string;
}

export const HomeIcon: React.FC<IconProps> = ({ color = "#CECECE" }) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 18.9999V10.898C3.5 10.3267 3.7443 9.78272 4.17127 9.40318L11.1713 3.18096C11.929 2.50739 13.071 2.50739 13.8287 3.18096L20.8287 9.40318C21.2557 9.78272 21.5 10.3267 21.5 10.898V18.9999C21.5 20.6567 20.1569 21.9999 18.5 21.9999H6.5C4.84315 21.9999 3.5 20.6567 3.5 18.9999ZM8.5 15.9999C7.94772 15.9999 7.5 16.4476 7.5 16.9999C7.5 17.5522 7.94772 17.9999 8.5 17.9999H16.5C17.0523 17.9999 17.5 17.5522 17.5 16.9999C17.5 16.4476 17.0523 15.9999 16.5 15.9999H8.5Z"
        fill={color}
      />
    </svg>
  );
};

export const InspectIcon: React.FC<IconProps> = ({ color = "#CECECE" }) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.5 1C8.39543 1 7.5 1.89543 7.5 3V4H6.5C5.39543 4 4.5 4.89543 4.5 6V20C4.5 21.1046 5.39543 22 6.5 22H18.5C19.6046 22 20.5 21.1046 20.5 20V6C20.5 4.89543 19.6046 4 18.5 4H17.5V3C17.5 1.89543 16.6046 1 15.5 1H9.5ZM9.5 3H15.5V5H9.5V3Z"
        fill={color}
      />
    </svg>
  );
};

export const MeasureIcon: React.FC<IconProps> = ({ color = "#CECECE" }) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.5 7C9.5 5.34315 10.8431 4 12.5 4C14.1569 4 15.5 5.34315 15.5 7V11C15.5 12.6569 14.1569 14 12.5 14C10.8431 14 9.5 12.6569 9.5 11V7ZM6.5 8C7.05228 8 7.5 8.44772 7.5 9V11C7.5 13.7614 9.73858 16 12.5 16C15.2614 16 17.5 13.7614 17.5 11V9C17.5 8.44772 17.9477 8 18.5 8C19.0523 8 19.5 8.44772 19.5 9V11C19.5 14.5265 16.8923 17.4439 13.5 17.9291V20C13.5 20.5523 13.0523 21 12.5 21C11.9477 21 11.5 20.5523 11.5 20V17.9291C8.10771 17.4439 5.5 14.5265 5.5 11V9C5.5 8.44772 5.94772 8 6.5 8Z"
        fill={color}
      />
    </svg>
  );
};

export const UserIcon: React.FC<IconProps> = ({ color = "#CECECE" }) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 10C14.1569 10 15.5 8.65685 15.5 7C15.5 5.34315 14.1569 4 12.5 4C10.8431 4 9.5 5.34315 9.5 7C9.5 8.65685 10.8431 10 12.5 10ZM19.5 19.7308C19.5 16.0135 16.4865 13 12.7692 13H12.2308C8.51347 13 5.5 16.0135 5.5 19.7308C5.5 19.8795 5.62054 20 5.76923 20H19.2308C19.3795 20 19.5 19.8795 19.5 19.7308Z"
        fill={color}
      />
    </svg>
  );
};

export const MainBellIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.99708 7.97979C4.99808 8.00081 4.99908 8.01891 5 8.03392V11.5858L3.29289 13.2929L3 13.5858V14V17V18H4H8C8 20.2091 9.79086 22 12 22C14.2091 22 16 20.2091 16 18H20H21V17V14V13.5858L20.7071 13.2929L19 11.5858V8.03391C19.0009 8.0189 19.0019 8.00081 19.0029 7.97979C19.0056 7.92309 19.0082 7.84486 19.0088 7.74814C19.0099 7.5551 19.003 7.28603 18.9719 6.96573C18.9101 6.33058 18.7503 5.46414 18.3466 4.58335C17.9395 3.6952 17.2793 2.78315 16.2239 2.09854C15.1675 1.41329 13.7829 1 12 1C10.2171 1 8.83254 1.41329 7.77612 2.09854C6.72068 2.78315 6.0605 3.6952 5.65344 4.58335C5.24974 5.46414 5.08988 6.33058 5.02813 6.96573C4.99699 7.28603 4.99008 7.5551 4.99123 7.74814C4.9918 7.84486 4.99441 7.92309 4.99708 7.97979ZM14 18H10C10 19.1046 10.8954 20 12 20C13.1046 20 14 19.1046 14 18ZM16 16H19V14.4142L17.2929 12.7071L17 12.4142V12V8V7.95841L17.0031 7.92112L17.0031 7.92112L17.0032 7.92009L17.0034 7.91707C17.0038 7.91169 17.0044 7.90103 17.0051 7.88545C17.0066 7.85425 17.0084 7.80358 17.0088 7.73624C17.0096 7.60115 17.0048 7.40147 16.9813 7.15927C16.9336 6.66942 16.8122 6.03585 16.5284 5.41665C16.248 4.8048 15.8144 4.21685 15.1355 3.77646C14.4575 3.33671 13.4671 3 12 3C10.5329 3 9.54246 3.33671 8.8645 3.77646C8.18557 4.21685 7.752 4.8048 7.47156 5.41665C7.18776 6.03585 7.06637 6.66942 7.01874 7.15927C6.9952 7.40147 6.99039 7.60115 6.99119 7.73624C6.99159 7.80358 6.99339 7.85425 6.99486 7.88545C6.99559 7.90103 6.99625 7.91169 6.9966 7.91707L6.99681 7.92009L7 7.95841V8V12V12.4142L6.70711 12.7071L5 14.4142V16H8H9H15H16Z"
        fill="#242629"
      />
    </svg>
  );
};

export const MainSettingIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" fill="white" />
      <path
        d="M15.2243 19.3318C15.0776 19.4418 14.964 19.5901 14.8959 19.7604L14.2514 21.3714C14.0996 21.751 13.7319 22 13.323 22H10.677C10.2681 22 9.90042 21.751 9.74856 21.3714L9.10414 19.7604C9.03603 19.5901 8.92239 19.4418 8.77567 19.3318L7.41916 18.3144C7.15665 18.1175 6.81424 18.0619 6.50293 18.1657L4.82279 18.7257C4.35068 18.8831 3.83469 18.6694 3.61213 18.2243L2.41413 15.8283C2.18045 15.3609 2.34599 14.7924 2.79407 14.5236L4.0145 13.7913C4.3157 13.6106 4.5 13.2851 4.5 12.9338V11.4806C4.5 11.1768 4.36191 10.8895 4.1247 10.6998L2.63127 9.50501C2.26306 9.21045 2.15066 8.69869 2.36153 8.27693L3.61213 5.77573C3.83469 5.33062 4.35068 5.11689 4.82279 5.27426L6.60704 5.86901C6.85865 5.95288 7.13327 5.93337 7.37048 5.81476L8.62952 5.18524C8.86673 5.06663 9.04712 4.85865 9.13099 4.60704L9.77208 2.68377C9.90819 2.27543 10.2903 2 10.7208 2H13.2792C13.7097 2 14.0918 2.27543 14.2279 2.68377L14.869 4.60704C14.9529 4.85865 15.1333 5.06663 15.3705 5.18524L16.6295 5.81476C16.8667 5.93337 17.1414 5.95288 17.393 5.86901L19.1772 5.27426C19.6493 5.11689 20.1653 5.33062 20.3879 5.77573L21.6385 8.27693C21.8493 8.69869 21.7369 9.21045 21.3687 9.50501L19.8753 10.6998C19.6381 10.8895 19.5 11.1768 19.5 11.4806V12.5194C19.5 12.8232 19.6381 13.1105 19.8753 13.3002L21.3687 14.495C21.7369 14.7896 21.8493 15.3013 21.6385 15.7231L20.3879 18.2243C20.1653 18.6694 19.6493 18.8831 19.1772 18.7257L17.4971 18.1657C17.1858 18.0619 16.8434 18.1175 16.5808 18.3144L15.2243 19.3318Z"
        stroke="#242629"
        strokeWidth="2"
      />
      <path
        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
        fill="#242629"
      />
    </svg>
  );
};

export const BackArrowIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M15 6L9 12L15 18" stroke="#020617" strokeLinecap="round" />
    </svg>
  );
};

export const InvisibleIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.00003 5C4.55231 5 5.00003 5.44772 5.00003 6C5.00003 9.86599 8.13403 13 12 13C15.866 13 19 9.86599 19 6C19 5.44772 19.4477 5 20 5C20.5523 5 21 5.44772 21 6C21 7.87864 20.4244 9.62285 19.44 11.0659L21.7682 13.8598C22.1218 14.2841 22.0645 14.9147 21.6402 15.2682C21.2159 15.6218 20.5854 15.5645 20.2318 15.1402L18.1167 12.6021C17.3044 13.355 16.3528 13.9599 15.305 14.3738L16.8945 17.5528C17.1414 18.0468 16.9412 18.6474 16.4472 18.8944C15.9533 19.1414 15.3526 18.9412 15.1056 18.4472L13.333 14.902C12.898 14.9665 12.4529 15 12 15C11.5471 15 11.102 14.9665 10.6671 14.902L8.89445 18.4472C8.64746 18.9412 8.04679 19.1414 7.55281 18.8944C7.05883 18.6474 6.85861 18.0468 7.1056 17.5528L8.69509 14.3738C7.64724 13.9599 6.69569 13.355 5.88336 12.6021L3.76825 15.1402C3.41468 15.5645 2.78412 15.6218 2.35984 15.2682C1.93556 14.9147 1.87824 14.2841 2.2318 13.8598L4.56009 11.0659C3.57563 9.62285 3.00003 7.87864 3.00003 6C3.00003 5.44772 3.44774 5 4.00003 5Z"
        fill="black"
      />
    </svg>
  );
};

export const VisibleIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 14C19 14.5523 19.4477 15 20 15C20.5523 15 21 14.5523 21 14C21 9.02944 16.9706 5 12 5C7.02944 5 3 9.02944 3 14C3 14.5523 3.44772 15 4 15C4.55229 15 5 14.5523 5 14C5 10.134 8.13401 7 12 7C15.866 7 19 10.134 19 14ZM10 13C10 11.8954 10.8954 11 12 11C13.1046 11 14 11.8954 14 13C14 14.1046 13.1046 15 12 15C10.8954 15 10 14.1046 10 13ZM12 9C9.79086 9 8 10.7909 8 13C8 15.2091 9.79086 17 12 17C14.2091 17 16 15.2091 16 13C16 10.7909 14.2091 9 12 9Z"
        fill="black"
      />
    </svg>
  );
};

export const CameraIcon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12.5" cy="12" r="11.5" fill="#D9D9D9" stroke="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 10.25V16C5.5 17.1046 6.39543 18 7.5 18H18.5C19.6046 18 20.5 17.1046 20.5 16V10.25C20.5 9.14543 19.6046 8.25 18.5 8.25H17.8204C17.1517 8.25 16.5272 7.9158 16.1563 7.3594L15.8437 6.8906C15.4728 6.3342 14.8483 6 14.1796 6H11.8204C11.1517 6 10.5272 6.3342 10.1563 6.8906L9.84373 7.3594C9.4728 7.9158 8.84834 8.25 8.17963 8.25H7.5C6.39543 8.25 5.5 9.14543 5.5 10.25ZM13 15C14.2426 15 15.25 13.9926 15.25 12.75C15.25 11.5074 14.2426 10.5 13 10.5C11.7573 10.5 10.75 11.5074 10.75 12.75C10.75 13.9926 11.7573 15 13 15Z"
        fill="white"
      />
    </svg>
  );
};

export const CancelIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.3536 7.35355C17.5488 7.15829 17.5488 6.84171 17.3536 6.64645C17.1583 6.45118 16.8417 6.45118 16.6464 6.64645L12 11.2929L7.35355 6.64645C7.15829 6.45118 6.84171 6.45118 6.64645 6.64645C6.45118 6.84171 6.45118 7.15829 6.64645 7.35355L11.2929 12L6.64645 16.6464C6.45118 16.8417 6.45118 17.1583 6.64645 17.3536C6.84171 17.5488 7.15829 17.5488 7.35355 17.3536L12 12.7071L16.6464 17.3536C16.8417 17.5488 17.1583 17.5488 17.3536 17.3536C17.5488 17.1583 17.5488 16.8417 17.3536 16.6464L12.7071 12L17.3536 7.35355Z"
        fill="#020617"
      />
    </svg>
  );
};

export const CancelSmIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="6" fill="black" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6952 11.4023C10.8905 11.5976 11.207 11.5976 11.4023 11.4023C11.5976 11.207 11.5976 10.8904 11.4023 10.6952L8.70707 7.99995L11.4023 5.30473C11.5975 5.10946 11.5975 4.79288 11.4023 4.59762C11.207 4.40236 10.8904 4.40236 10.6952 4.59762L7.99996 7.29284L5.30474 4.59762C5.10948 4.40236 4.79289 4.40236 4.59763 4.59762C4.40237 4.79288 4.40237 5.10946 4.59763 5.30473L7.29285 7.99995L4.59762 10.6952C4.40236 10.8904 4.40236 11.207 4.59762 11.4023C4.79288 11.5976 5.10946 11.5976 5.30473 11.4023L7.99996 8.70705L10.6952 11.4023Z"
        fill="white"
      />
    </svg>
  );
};

export const CaptureIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.36326 12.8488L7.32118 9.18409C7.55879 8.96409 7.67759 8.85408 7.81459 8.81287C7.9351 8.77661 8.0649 8.77661 8.18541 8.81287C8.32241 8.85408 8.44122 8.96409 8.67882 9.1841L12.6104 12.8244M9.2 9.66667L10.9212 8.07298C11.1588 7.85297 11.2776 7.74297 11.4146 7.70175C11.5351 7.6655 11.6649 7.6655 11.7854 7.70175C11.9224 7.74297 12.0412 7.85297 12.2788 8.07298L14 9.66667M6.8 6.33333C6.8 6.94698 6.26274 7.44444 5.6 7.44444C4.93726 7.44444 4.4 6.94698 4.4 6.33333C4.4 5.71968 4.93726 5.22222 5.6 5.22222C6.26274 5.22222 6.8 5.71968 6.8 6.33333ZM4.88 13H11.12C12.1281 13 12.6321 13 13.0172 12.8183C13.3559 12.6586 13.6312 12.4036 13.8038 12.09C14 11.7335 14 11.2668 14 10.3333V5.66667C14 4.73325 14 4.26654 13.8038 3.91002C13.6312 3.59641 13.3559 3.34144 13.0172 3.18166C12.6321 3 12.1281 3 11.12 3H4.88C3.87191 3 3.36786 3 2.98282 3.18166C2.64413 3.34144 2.36876 3.59641 2.19619 3.91002C2 4.26654 2 4.73325 2 5.66667V10.3333C2 11.2668 2 11.7335 2.19619 12.09C2.36876 12.4036 2.64413 12.6586 2.98282 12.8183C3.36786 13 3.87191 13 4.88 13Z"
        stroke="#242629"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const KakaoSimbol = () => {
  return (
    <svg
      width="800px"
      height="800px"
      viewBox="0 0 512 512"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#000000"
        d="M255.5 48C299.345 48 339.897 56.5332 377.156 73.5996C414.415 90.666 443.871 113.873 465.522 143.22C487.174 172.566 498 204.577 498 239.252C498 273.926 487.174 305.982 465.522 335.42C443.871 364.857 414.46 388.109 377.291 405.175C340.122 422.241 299.525 430.775 255.5 430.775C241.607 430.775 227.262 429.781 212.467 427.795C148.233 472.402 114.042 494.977 109.892 495.518C107.907 496.241 106.012 496.15 104.208 495.248C103.486 494.706 102.945 493.983 102.584 493.08C102.223 492.177 102.043 491.365 102.043 490.642V489.559C103.126 482.515 111.335 453.169 126.672 401.518C91.8486 384.181 64.1974 361.2 43.7185 332.575C23.2395 303.951 13 272.843 13 239.252C13 204.577 23.8259 172.566 45.4777 143.22C67.1295 113.873 96.5849 90.666 133.844 73.5996C171.103 56.5332 211.655 48 255.5 48Z"
      ></path>
    </svg>
  );
};

export const GoogleSimbol = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.8445 10.4332H19.2001V10.4H12V13.6H16.5213C15.8617 15.4628 14.0892 16.8001 12 16.8001C9.34922 16.8001 7.20001 14.6508 7.20001 12C7.20001 9.34922 9.34922 7.20001 12 7.20001C13.2236 7.20001 14.3368 7.66162 15.1844 8.41562L17.4473 6.15281C16.0185 4.8212 14.1072 4 12 4C7.58202 4 4 7.58202 4 12C4 16.4181 7.58202 20.0001 12 20.0001C16.4181 20.0001 20.0001 16.4181 20.0001 12C20.0001 11.4636 19.9449 10.94 19.8445 10.4332Z"
        fill="#FFC107"
      />
      <path
        d="M4.92188 8.27642L7.55029 10.204C8.26149 8.44322 9.9839 7.20001 11.9995 7.20001C13.2231 7.20001 14.3363 7.66162 15.1839 8.41562L17.4467 6.15281C16.0179 4.8212 14.1067 4 11.9995 4C8.92669 4 6.26188 5.73481 4.92188 8.27642Z"
        fill="#FF3D00"
      />
      <path
        d="M12.0009 20.0005C14.0673 20.0005 15.945 19.2097 17.3646 17.9237L14.8885 15.8285C14.0853 16.4369 13.0869 16.8005 12.0009 16.8005C9.92013 16.8005 8.15332 15.4737 7.48772 13.6221L4.87891 15.6321C6.20291 18.2229 8.89172 20.0005 12.0009 20.0005Z"
        fill="#4CAF50"
      />
      <path
        d="M19.8444 10.4331H19.2V10.3999H12V13.5999H16.5212C16.2044 14.4947 15.6288 15.2663 14.8864 15.8283C14.8868 15.8279 14.8872 15.8279 14.8876 15.8275L17.3636 17.9227C17.1884 18.0819 20 15.9999 20 11.9999C20 11.4635 19.9448 10.9399 19.8444 10.4331Z"
        fill="#1976D2"
      />
    </svg>
  );
};

export const GoogleSimbolVer2 = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8445 6.43323H15.2001V6.40003H8.00003V9.60004H12.5213C11.8617 11.4628 10.0892 12.8001 8.00003 12.8001C5.34922 12.8001 3.20001 10.6508 3.20001 8.00003C3.20001 5.34922 5.34922 3.20001 8.00003 3.20001C9.22364 3.20001 10.3368 3.66162 11.1844 4.41562L13.4473 2.15281C12.0185 0.821203 10.1072 0 8.00003 0C3.58202 0 0 3.58202 0 8.00003C0 12.4181 3.58202 16.0001 8.00003 16.0001C12.4181 16.0001 16.0001 12.4181 16.0001 8.00003C16.0001 7.46363 15.9449 6.94003 15.8445 6.43323Z"
        fill="#FFC107"
      />
      <path
        d="M0.921875 4.27642L3.55029 6.20403C4.26149 4.44322 5.9839 3.20001 7.99951 3.20001C9.22311 3.20001 10.3363 3.66162 11.1839 4.41562L13.4467 2.15281C12.0179 0.821203 10.1067 0 7.99951 0C4.92669 0 2.26188 1.73481 0.921875 4.27642Z"
        fill="#FF3D00"
      />
      <path
        d="M8.00094 16.0005C10.0673 16.0005 11.945 15.2097 13.3646 13.9237L10.8885 11.8285C10.0853 12.4369 9.08694 12.8005 8.00094 12.8005C5.92013 12.8005 4.15332 11.4737 3.48772 9.62207L0.878906 11.6321C2.20291 14.2229 4.89172 16.0005 8.00094 16.0005Z"
        fill="#4CAF50"
      />
      <path
        d="M15.8444 6.4331H15.2V6.3999H8V9.59992H12.5212C12.2044 10.4947 11.6288 11.2663 10.8864 11.8283C10.8868 11.8279 10.8872 11.8279 10.8876 11.8275L13.3636 13.9227C13.1884 14.0819 16 11.9999 16 7.99991C16 7.46351 15.9448 6.9399 15.8444 6.4331Z"
        fill="#1976D2"
      />
    </svg>
  );
};

export const LeftArrowIcon = (props: any) => {
  const { color = "#cecece", onClick } = props;
  return (
    <div onClick={onClick} className="slick-arrow-left slick-arrow-custom">
      <svg
        width="14"
        height="15"
        viewBox="0 0 14 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.75 4L5.25 7.5L8.75 11"
          stroke={color}
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};

export const RightArrowIcon = (props: any) => {
  const { color = "#000", onClick } = props;
  return (
    <div onClick={onClick} className="slick-arrow-right slick-arrow-custom">
      <svg
        width="14"
        height="15"
        viewBox="0 0 14 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.25 11L8.75 7.5L5.25 4"
          stroke={color}
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};

export const ShareIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="12" fill="#ECECEC" />
      <path
        d="M15.1667 15.1888C14.7022 15.1888 14.2867 15.3845 13.9689 15.6913L9.61167 12.9829C9.64222 12.8328 9.66667 12.6827 9.66667 12.5261C9.66667 12.3695 9.64222 12.2194 9.61167 12.0693L13.92 9.38705C14.25 9.71335 14.6839 9.91566 15.1667 9.91566C16.1811 9.91566 17 9.04116 17 7.95783C17 6.8745 16.1811 6 15.1667 6C14.1522 6 13.3333 6.8745 13.3333 7.95783C13.3333 8.11446 13.3578 8.26456 13.3883 8.41466L9.08 11.0969C8.75 10.7706 8.31611 10.5683 7.83333 10.5683C6.81889 10.5683 6 11.4428 6 12.5261C6 13.6094 6.81889 14.4839 7.83333 14.4839C8.31611 14.4839 8.75 14.2816 9.08 13.9553L13.4311 16.6702C13.4006 16.8072 13.3822 16.9508 13.3822 17.0944C13.3822 18.1451 14.1828 19 15.1667 19C16.1506 19 16.9511 18.1451 16.9511 17.0944C16.9511 16.0437 16.1506 15.1888 15.1667 15.1888Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};

export const HeartIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.53065 12.1967L3.49542 8.16144C2.96499 7.631 2.66699 6.91158 2.66699 6.16143C2.66699 4.59934 3.93332 3.33301 5.49542 3.33301C6.24556 3.33301 6.96499 3.631 7.49542 4.16144L7.96889 4.63491C7.98625 4.65227 8.0144 4.65227 8.03176 4.63491L8.50523 4.16144C9.03566 3.631 9.75509 3.33301 10.5052 3.33301C12.0673 3.33301 13.3337 4.59934 13.3337 6.16143C13.3337 6.91158 13.0357 7.631 12.5052 8.16144L8.47 12.1967C8.21061 12.4561 7.79004 12.4561 7.53065 12.1967Z"
        fill="#E3A784"
      />
    </svg>
  );
};

export const HeartIconX14 = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.651 7.45238L6.99987 11.7035L11.3487 7.45238L11.3722 7.42942C12.5743 6.25431 12.5743 4.35283 11.3722 3.17826C10.1701 2.0037 8.2249 2.00316 7.02335 3.17826L6.99987 3.20122L6.97582 3.17772C5.77371 2.00261 3.82852 2.00261 2.62696 3.17772C1.42541 4.35283 1.42485 6.25431 2.62696 7.42888L2.651 7.45238Z"
        stroke="#575757"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const WhiteLineHeartIconX14 = () => {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.651 7.86205L6.99987 12.1132L11.3487 7.86205L11.3722 7.83909C12.5743 6.66398 12.5743 4.76249 11.3722 3.58793C10.1701 2.41337 8.22491 2.41282 7.02335 3.58793L6.99987 3.61089L6.97582 3.58739C5.77371 2.41228 3.82852 2.41228 2.62696 3.58739C1.42541 4.76249 1.42485 6.66398 2.62696 7.83854L2.651 7.86205Z"
        fill="#242629"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RepleIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 3.5C1 2.67157 1.67157 2 2.5 2H11.5599C12.3883 2 13.0599 2.67157 13.0599 3.5V9.5C13.0599 10.3284 12.3883 11 11.5599 11H9.33333C9.22515 11 9.11988 11.0351 9.03333 11.1L7.36 12.355C7.14667 12.515 6.85333 12.515 6.64 12.355L4.96667 11.1C4.88012 11.0351 4.77485 11 4.66667 11H2.5C1.67157 11 1 10.3284 1 9.5V3.5ZM2.5 3C2.22386 3 2 3.22386 2 3.5V9.5C2 9.77614 2.22386 10 2.5 10H4.66667C4.99122 10 5.30702 10.1053 5.56667 10.3L7 11.375L8.43333 10.3C8.69298 10.1053 9.00878 10 9.33333 10H11.5599C11.8361 10 12.0599 9.77614 12.0599 9.5V3.5C12.0599 3.22386 11.8361 3 11.5599 3H2.5Z"
        fill="#575757"
      />
      <path
        d="M4 5.5L7 5.5L10.03 5.5M4 7.5L7 7.5L10 7.5"
        stroke="#575757"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const RepleIconX14 = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 3.5C1 2.67157 1.67157 2 2.5 2H11.5599C12.3883 2 13.0599 2.67157 13.0599 3.5V9.5C13.0599 10.3284 12.3883 11 11.5599 11H9.33333C9.22515 11 9.11988 11.0351 9.03333 11.1L7.36 12.355C7.14667 12.515 6.85333 12.515 6.64 12.355L4.96667 11.1C4.88012 11.0351 4.77485 11 4.66667 11H2.5C1.67157 11 1 10.3284 1 9.5V3.5ZM2.5 3C2.22386 3 2 3.22386 2 3.5V9.5C2 9.77614 2.22386 10 2.5 10H4.66667C4.99122 10 5.30702 10.1053 5.56667 10.3L7 11.375L8.43333 10.3C8.69298 10.1053 9.00878 10 9.33333 10H11.5599C11.8361 10 12.0599 9.77614 12.0599 9.5V3.5C12.0599 3.22386 11.8361 3 11.5599 3H2.5Z"
        fill="white"
      />
      <path
        d="M4 5.5L7 5.5L10.03 5.5M4 7.5L7 7.5L10 7.5"
        stroke="white"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const MoreIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 7.5C11.7239 7.5 11.5 7.27614 11.5 7C11.5 6.72386 11.7239 6.5 12 6.5C12.2761 6.5 12.5 6.72386 12.5 7C12.5 7.27614 12.2761 7.5 12 7.5Z"
        fill="#020617"
        stroke="#242629"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 12.5C11.7239 12.5 11.5 12.2761 11.5 12C11.5 11.7239 11.7239 11.5 12 11.5C12.2761 11.5 12.5 11.7239 12.5 12C12.5 12.2761 12.2761 12.5 12 12.5Z"
        stroke="#242629"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 17.5C11.7239 17.5 11.5 17.2761 11.5 17C11.5 16.7239 11.7239 16.5 12 16.5C12.2761 16.5 12.5 16.7239 12.5 17C12.5 17.2761 12.2761 17.5 12 17.5Z"
        stroke="#242629"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LinkIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="12" fill="#CECECE" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.2817 6.0708C14.5803 4.64307 16.7275 4.64307 18.0261 6.0708C19.3246 7.49853 19.3246 9.85936 18.0261 11.2871L15.6562 13.8927C14.5283 15.2355 12.6928 15.3061 11.4283 14.3792C10.9864 14.0554 10.867 13.399 11.1616 12.9132C11.4562 12.4274 12.0531 12.2961 12.495 12.62C13.0703 13.0417 13.8381 12.9485 14.2501 12.4502C14.2604 12.4378 14.2709 12.4257 14.2817 12.4138L16.6663 9.79203C17.2138 9.19 17.2138 8.16789 16.6663 7.56586C16.1383 6.98538 15.2551 6.9646 14.7017 7.50351L14.6078 7.65846C14.3132 8.14426 13.7162 8.27553 13.2744 7.95167C12.8326 7.6278 12.7132 6.97144 13.0077 6.48564L13.1616 6.23192C13.1967 6.17399 13.2369 6.12003 13.2817 6.0708Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.81559 10.0112C10.0896 8.8842 12.0503 8.58834 13.5672 9.69536C14.0452 10.0442 14.142 10.7039 13.7836 11.1689C13.4251 11.634 12.7471 11.7282 12.2692 11.3795C11.716 10.9757 10.9202 11.0108 10.2938 11.5489L7.6375 14.2169L7.62546 14.2289C7.00944 14.8283 7.00944 15.8459 7.62546 16.4453C8.24147 17.0447 9.28732 17.0447 9.90334 16.4453L10.6682 17.1896L9.90334 16.4453L10.163 16.1927C10.5854 15.7817 11.2703 15.7817 11.6927 16.1927C12.1152 16.6038 12.1152 17.2702 11.6927 17.6813L11.4331 17.9339C9.97223 19.3554 7.55656 19.3554 6.09567 17.9339C4.63697 16.5145 4.63478 14.1689 6.08909 12.7467L8.7663 10.0577C8.78222 10.0417 8.79866 10.0262 8.81559 10.0112Z"
        fill="black"
      />
    </svg>
  );
};

export const ReveiwDetailHeaderLeftIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2929 9.70726C16.6834 10.0978 17.3166 10.0978 17.7071 9.70726C18.0976 9.31673 18.0976 8.68357 17.7071 8.29304L12.7071 3.29304L12 2.58594L11.2929 3.29304L6.29289 8.29304C5.90237 8.68357 5.90237 9.31673 6.29289 9.70726C6.68342 10.0978 7.31658 10.0978 7.70711 9.70726L11 6.41436L11 16.0002C11 16.5524 11.4477 17.0002 12 17.0002C12.5523 17.0002 13 16.5524 13 16.0002L13 6.41436L16.2929 9.70726ZM5 14.0002C5 13.4479 4.55228 13.0002 4 13.0002C3.44772 13.0002 3 13.4479 3 14.0002V18.0002C3 19.657 4.34315 21.0002 6 21.0002H18C19.6569 21.0002 21 19.657 21 18.0002V14.0002C21 13.4479 20.5523 13.0002 20 13.0002C19.4477 13.0002 19 13.4479 19 14.0002V18.0002C19 18.5524 18.5523 19.0002 18 19.0002H6C5.44772 19.0002 5 18.5524 5 18.0002V14.0002Z"
        fill="#020617"
      />
    </svg>
  );
};

export const ReviewDetailHeaderRightIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12Z"
        fill="#020617"
        stroke="#242629"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19Z"
        stroke="#242629"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 5C11 5.55228 11.4477 6 12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5Z"
        stroke="#242629"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PlusIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 3.42871V12.5716"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.42871 8H12.5716"
        stroke="#AFAFAF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DonwArrowIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.70731 13.3737L8.70711 13.3739L8 14.081L7.29289 13.3739L3.29289 9.37394C2.90237 8.98341 2.90237 8.35025 3.29289 7.95972C3.68342 7.5692 4.31658 7.5692 4.70711 7.95972L7 10.2526L7 3.3335C7 2.78121 7.44772 2.3335 8 2.3335C8.55229 2.3335 9 2.78121 9 3.3335L9 10.2526L11.2929 7.95972C11.6834 7.5692 12.3166 7.5692 12.7071 7.95972C13.0976 8.35025 13.0976 8.98341 12.7071 9.37394L8.70731 13.3737Z"
        fill="black"
      />
    </svg>
  );
};

export const CheckIconX24 = ({ color = "black" }: { color?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 11L11 16L19 8"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const DownArrowIconX24 = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 9L12 15L18 9"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const PinIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6673 2.83301H9.74863C9.80391 2.9894 9.83398 3.15769 9.83398 3.33301V5.41879C9.83398 5.5514 9.88666 5.67858 9.98043 5.77235L10.5613 6.35323C10.8426 6.63453 11.0007 7.01606 11.0007 7.41389V7.74967C11.0007 8.5781 10.3291 9.24967 9.50065 9.24967H7.50065V11.6663C7.50065 11.9425 7.27679 12.1663 7.00065 12.1663C6.72451 12.1663 6.50065 11.9425 6.50065 11.6663V9.24967H4.50065C3.67222 9.24967 3.00065 8.5781 3.00065 7.74967V7.41389C3.00065 7.01606 3.15869 6.63453 3.43999 6.35323L4.02087 5.77235C4.11464 5.67858 4.16732 5.5514 4.16732 5.41879V3.33301C4.16732 3.15769 4.19739 2.9894 4.25267 2.83301H2.33398V1.83301H5.66732H8.33398H11.6673V2.83301ZM7.00065 8.24967H9.50065C9.77679 8.24967 10.0007 8.02582 10.0007 7.74967V7.41389C10.0007 7.28128 9.94797 7.1541 9.8542 7.06033L9.27332 6.47945C8.99202 6.19815 8.83398 5.81662 8.83398 5.41879V3.33301C8.83398 3.05687 8.61013 2.83301 8.33398 2.83301H5.66732C5.39118 2.83301 5.16732 3.05686 5.16732 3.33301V5.41879C5.16732 5.81662 5.00928 6.19815 4.72798 6.47945L4.1471 7.06033C4.05333 7.1541 4.00065 7.28128 4.00065 7.41389V7.74967C4.00065 8.02582 4.22451 8.24967 4.50065 8.24967H7.00065Z"
        fill="black"
      />
    </svg>
  );
};

export const AlertCircleIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 2.25C4.37665 2.25 2.25 4.37665 2.25 7C2.25 9.62335 4.37665 11.75 7 11.75C9.62335 11.75 11.75 9.62335 11.75 7C11.75 4.37665 9.62335 2.25 7 2.25ZM1.25 7C1.25 3.82436 3.82436 1.25 7 1.25C10.1756 1.25 12.75 3.82436 12.75 7C12.75 10.1756 10.1756 12.75 7 12.75C3.82436 12.75 1.25 10.1756 1.25 7ZM7 4.16667C7.27614 4.16667 7.5 4.39052 7.5 4.66667V7.16667C7.5 7.44281 7.27614 7.66667 7 7.66667C6.72386 7.66667 6.5 7.44281 6.5 7.16667V4.66667C6.5 4.39052 6.72386 4.16667 7 4.16667ZM7.5 9C7.5 8.72386 7.27614 8.5 7 8.5C6.72386 8.5 6.5 8.72386 6.5 9V9.4C6.5 9.67614 6.72386 9.9 7 9.9C7.27614 9.9 7.5 9.67614 7.5 9.4V9Z"
        fill="black"
      />
    </svg>
  );
};

export const RightArrowIconX16 = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 12.4097L10 8.40967L6 4.40967"
        stroke="#242629"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const RadioIconX16 = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="7.5" fill="white" stroke="black" />
    </svg>
  );
};

export const RadioIconCheckedX16 = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="7.5" fill="white" stroke="black" />
      <circle cx="8" cy="8" r="4" fill="black" />
    </svg>
  );
};

export const CheckboxDefault = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="15"
        height="15"
        fill="white"
        stroke="black"
      />
    </svg>
  );
};

export const CheckBoxChecked = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="15"
        height="15"
        fill="white"
        stroke="black"
      />
      <path
        d="M4 8.5L7.59999 11.0001L12 4"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="square"
      />
    </svg>
  );
};

export const ListDotIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="8" y="8" width="4" height="4" rx="1" fill="#878B93" />
    </svg>
  );
};

export const LeftNavigationIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="2.25"
        y="2.25"
        width="35.5"
        height="35.5"
        rx="17.75"
        fill="white"
      />
      <rect
        x="2.25"
        y="2.25"
        width="35.5"
        height="35.5"
        rx="17.75"
        stroke="#CECECE"
        strokeWidth="0.5"
      />
      <path
        d="M22.5 25L17.5 20L22.5 15"
        stroke="#CECECE"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const RightNavigation = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="2.25"
        y="2.25"
        width="35.5"
        height="35.5"
        rx="17.75"
        fill="white"
      />
      <rect
        x="2.25"
        y="2.25"
        width="35.5"
        height="35.5"
        rx="17.75"
        stroke="#CECECE"
        strokeWidth="0.5"
      />
      <path
        d="M17.5 25L22.5 20L17.5 15"
        stroke="#CECECE"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const AdminSearchIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 10C4 6.68629 6.68629 4 10 4C13.3137 4 16 6.68629 16 10C16 13.3137 13.3137 16 10 16C6.68629 16 4 13.3137 4 10ZM10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C11.8487 18 13.551 17.3729 14.9056 16.3199L20.2929 21.7071C20.6834 22.0976 21.3166 22.0976 21.7071 21.7071C22.0976 21.3166 22.0976 20.6834 21.7071 20.2929L16.3199 14.9056C17.3729 13.551 18 11.8487 18 10C18 5.58172 14.4183 2 10 2Z"
        fill="#242629"
      />
    </svg>
  );
};

export const BackArrowAdminIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M15 6L9 12L15 18"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const AdminModalClosedIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.7071 7.70711C18.0976 7.31658 18.0976 6.68342 17.7071 6.29289C17.3166 5.90237 16.6834 5.90237 16.2929 6.29289L12 10.5858L7.70711 6.29289C7.31658 5.90237 6.68342 5.90237 6.29289 6.29289C5.90237 6.68342 5.90237 7.31658 6.29289 7.70711L10.5858 12L6.29289 16.2929C5.90237 16.6834 5.90237 17.3166 6.29289 17.7071C6.68342 18.0976 7.31658 18.0976 7.70711 17.7071L12 13.4142L16.2929 17.7071C16.6834 18.0976 17.3166 18.0976 17.7071 17.7071C18.0976 17.3166 18.0976 16.6834 17.7071 16.2929L13.4142 12L17.7071 7.70711Z"
        fill="black"
      />
    </svg>
  );
};

export const UpArrowIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 7L4 15H20L12 7Z" fill="black" />
    </svg>
  );
};

export const DownArrowIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 17L4 9H20L12 17Z" fill="black" />
    </svg>
  );
};

export const DoubleArrowIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.29289 17.7929C4.90237 18.1834 4.90237 18.8166 5.29289 19.2071C5.68342 19.5976 6.31658 19.5976 6.70711 19.2071L12.7071 13.2071L13.4142 12.5L12.7071 11.7929L6.70711 5.79289C6.31658 5.40237 5.68342 5.40237 5.29289 5.79289C4.90237 6.18342 4.90237 6.81658 5.29289 7.20711L10.5858 12.5L5.29289 17.7929ZM12.2929 17.7929C11.9024 18.1834 11.9024 18.8166 12.2929 19.2071C12.6834 19.5976 13.3166 19.5976 13.7071 19.2071L19.7071 13.2071L20.4142 12.5L19.7071 11.7929L13.7071 5.79289C13.3166 5.40237 12.6834 5.40237 12.2929 5.79289C11.9024 6.18342 11.9024 6.81658 12.2929 7.20711L17.5858 12.5L12.2929 17.7929Z"
        fill="white"
      />
    </svg>
  );
};

export const LegendIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10ZM10 12.3333C10.5523 12.3333 11 12.781 11 13.3333V14.1667C11 14.719 10.5523 15.1667 10 15.1667C9.44772 15.1667 9 14.719 9 14.1667V13.3333C9 12.781 9.44772 12.3333 10 12.3333ZM8.5 8.33333C8.5 7.50491 9.17157 6.83333 10 6.83333C10.8284 6.83333 11.5 7.50491 11.5 8.33333C11.5 9.16176 10.8284 9.83333 10 9.83333C9.44772 9.83333 9 10.281 9 10.8333C9 11.3856 9.44772 11.8333 10 11.8333C11.933 11.8333 13.5 10.2663 13.5 8.33333C13.5 6.40034 11.933 4.83333 10 4.83333C8.067 4.83333 6.5 6.40034 6.5 8.33333C6.5 8.88562 6.94772 9.33333 7.5 9.33333C8.05228 9.33333 8.5 8.88562 8.5 8.33333Z"
        fill="#A1A1A1"
      />
    </svg>
  );
};

export const PageClosedIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.3536 7.35355C17.5488 7.15829 17.5488 6.84171 17.3536 6.64645C17.1583 6.45118 16.8417 6.45118 16.6464 6.64645L12 11.2929L7.35355 6.64645C7.15829 6.45118 6.84171 6.45118 6.64645 6.64645C6.45118 6.84171 6.45118 7.15829 6.64645 7.35355L11.2929 12L6.64645 16.6464C6.45118 16.8417 6.45118 17.1583 6.64645 17.3536C6.84171 17.5488 7.15829 17.5488 7.35355 17.3536L12 12.7071L16.6464 17.3536C16.8417 17.5488 17.1583 17.5488 17.3536 17.3536C17.5488 17.1583 17.5488 16.8417 17.3536 16.6464L12.7071 12L17.3536 7.35355Z"
        fill="#020617"
      />
    </svg>
  );
};

export const PauseIcon = () => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none">
      <path d="M14.5 19V5H18.5V19H14.5ZM6.5 19V5H10.5V19H6.5Z" fill="#1D1B20" />
    </svg>
  );
};

export const StartIcon = () => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none">
      <path d="M8 5V19L19 12L8 5Z" fill="#1D1B20" />
    </svg>
  );
};

export const DownChevronX16 = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M4 6L8 10L12 6" stroke="#242629" strokeLinecap="round" />
    </svg>
  );
};

export const UpChevronX16 = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M12 10L8 6L4 10" stroke="#242629" strokeLinecap="round" />
    </svg>
  );
};

export const AppleIcon = () => {
  return (
    <svg
      width="31"
      height="44"
      viewBox="0 0 31 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.1133 16.7788C19.2923 16.7788 19.5975 16.8073 20.0288 16.8643C20.4601 16.9212 20.9321 17.084 21.4448 17.3525C21.9657 17.613 22.4377 18.0483 22.8608 18.6587C22.8364 18.6831 22.7184 18.7726 22.5068 18.9272C22.2952 19.0737 22.0592 19.2935 21.7988 19.5864C21.5384 19.8713 21.3105 20.2375 21.1152 20.6851C20.9199 21.1245 20.8223 21.6494 20.8223 22.2598C20.8223 22.9596 20.9443 23.5537 21.1885 24.042C21.4408 24.5303 21.7297 24.925 22.0552 25.2261C22.3888 25.519 22.6818 25.7347 22.9341 25.873C23.1945 26.0114 23.3328 26.0846 23.3491 26.0928C23.341 26.1253 23.2352 26.4142 23.0317 26.9595C22.8364 27.5047 22.5109 28.111 22.0552 28.7783C21.6564 29.3561 21.2251 29.8892 20.7612 30.3774C20.3055 30.8657 19.7562 31.1099 19.1133 31.1099C18.682 31.1099 18.328 31.0488 18.0513 30.9268C17.7746 30.7965 17.4897 30.6704 17.1968 30.5483C16.9038 30.4181 16.5091 30.353 16.0127 30.353C15.5326 30.353 15.1297 30.4181 14.8042 30.5483C14.4868 30.6785 14.1816 30.8088 13.8887 30.939C13.6038 31.0692 13.2661 31.1343 12.8755 31.1343C12.2814 31.1343 11.7606 30.8983 11.313 30.4263C10.8654 29.9543 10.4056 29.3887 9.93359 28.7295C9.38835 27.9482 8.92041 26.9961 8.52979 25.873C8.1473 24.7419 7.95605 23.6025 7.95605 22.4551C7.95605 21.2262 8.18799 20.1968 8.65186 19.3667C9.11572 18.5285 9.7098 17.8978 10.4341 17.4746C11.1665 17.0433 11.9233 16.8276 12.7046 16.8276C13.1196 16.8276 13.5103 16.8968 13.8765 17.0352C14.2427 17.1654 14.5845 17.2996 14.9019 17.438C15.2274 17.5763 15.5203 17.6455 15.7808 17.6455C16.033 17.6455 16.326 17.5723 16.6597 17.4258C16.9933 17.2793 17.3677 17.1369 17.7827 16.9985C18.1978 16.8521 18.6413 16.7788 19.1133 16.7788ZM18.4419 15.2285C18.1245 15.611 17.7257 15.9325 17.2456 16.1929C16.7655 16.4451 16.3097 16.5713 15.8784 16.5713C15.7889 16.5713 15.7035 16.5632 15.6221 16.5469C15.6139 16.5225 15.6058 16.4777 15.5977 16.4126C15.5895 16.3475 15.5854 16.2783 15.5854 16.2051C15.5854 15.7168 15.6912 15.2448 15.9028 14.7891C16.1144 14.3252 16.3545 13.9427 16.623 13.6416C16.9648 13.2347 17.3962 12.897 17.917 12.6284C18.4378 12.3599 18.9342 12.2174 19.4062 12.2012C19.4307 12.307 19.4429 12.4331 19.4429 12.5796C19.4429 13.0679 19.3493 13.5439 19.1621 14.0078C18.9749 14.4635 18.7349 14.8704 18.4419 15.2285Z"
        fill="black"
      />
    </svg>
  );
};

export const AppleLabelIcon = () => {
  return (
    <svg width="165" height="19" viewBox="0 0 165 19" fill="none">
      <path
        d="M5.76221 14.8247C4.72314 14.8247 3.82015 14.667 3.05322 14.3516C2.29248 14.0299 1.69255 13.5815 1.25342 13.0063C0.81429 12.4312 0.563802 11.757 0.501953 10.9839L0.492676 10.854H2.82129L2.83057 10.9468C2.87386 11.3241 3.02539 11.6519 3.28516 11.9302C3.54492 12.2085 3.89437 12.4281 4.3335 12.5889C4.77262 12.7435 5.2736 12.8208 5.83643 12.8208C6.3807 12.8208 6.85693 12.7373 7.26514 12.5703C7.67952 12.4033 8.00114 12.1745 8.22998 11.8838C8.46501 11.5869 8.58252 11.2498 8.58252 10.8726V10.8633C8.58252 10.3747 8.39388 9.97884 8.0166 9.67578C7.64551 9.36654 7.02702 9.12223 6.16113 8.94287L4.72314 8.63672C3.35628 8.35221 2.36051 7.89144 1.73584 7.25439C1.11117 6.61735 0.798828 5.79785 0.798828 4.7959V4.78662C0.798828 3.98877 1.00911 3.28988 1.42969 2.68994C1.85645 2.09001 2.44092 1.62305 3.18311 1.28906C3.93148 0.955078 4.78809 0.788086 5.75293 0.788086C6.74251 0.788086 7.59912 0.955078 8.32275 1.28906C9.04639 1.61686 9.6154 2.06527 10.0298 2.63428C10.4442 3.20329 10.6761 3.84652 10.7256 4.56396L10.7349 4.69385H8.45264L8.43408 4.58252C8.37842 4.22998 8.23307 3.92074 7.99805 3.65479C7.76921 3.38265 7.46305 3.17236 7.07959 3.02393C6.69613 2.8693 6.24772 2.79199 5.73438 2.79199C5.23958 2.79199 4.80046 2.8693 4.41699 3.02393C4.03971 3.17236 3.73975 3.38265 3.51709 3.65479C3.30062 3.92692 3.19238 4.25472 3.19238 4.63818V4.64746C3.19238 5.11751 3.37484 5.50716 3.73975 5.81641C4.11084 6.11947 4.71387 6.35758 5.54883 6.53076L6.98682 6.83691C7.92692 7.03483 8.69076 7.29769 9.27832 7.62549C9.86589 7.95329 10.2957 8.36149 10.5679 8.8501C10.8462 9.33252 10.9854 9.9139 10.9854 10.5942V10.6035C10.9854 11.4694 10.772 12.2178 10.3452 12.8486C9.92464 13.4795 9.32161 13.9681 8.53613 14.3145C7.75684 14.6546 6.83219 14.8247 5.76221 14.8247ZM13.3789 14.5V4.3877H15.689V14.5H13.3789ZM14.5386 2.71777C14.1675 2.71777 13.8459 2.5848 13.5737 2.31885C13.3078 2.0529 13.1748 1.73438 13.1748 1.36328C13.1748 0.986003 13.3078 0.66748 13.5737 0.407715C13.8459 0.141764 14.1675 0.00878906 14.5386 0.00878906C14.922 0.00878906 15.2467 0.141764 15.5127 0.407715C15.7786 0.66748 15.9116 0.986003 15.9116 1.36328C15.9116 1.73438 15.7786 2.0529 15.5127 2.31885C15.2467 2.5848 14.922 2.71777 14.5386 2.71777ZM22.8232 18.0532C21.9326 18.0532 21.1657 17.9326 20.5225 17.6914C19.8792 17.4564 19.369 17.1255 18.9917 16.6987C18.6206 16.272 18.3949 15.7772 18.3145 15.2144V15.1772H20.6245L20.6338 15.2144C20.7204 15.536 20.9523 15.7988 21.3296 16.0029C21.7069 16.207 22.2171 16.3091 22.8604 16.3091C23.6458 16.3091 24.255 16.1297 24.688 15.771C25.1209 15.4185 25.3374 14.9206 25.3374 14.2773V12.3755H25.189C24.9972 12.7404 24.7498 13.0496 24.4468 13.3032C24.1437 13.5506 23.7943 13.7393 23.3984 13.8691C23.0026 13.999 22.5728 14.064 22.1089 14.064C21.2554 14.064 20.5163 13.8599 19.8916 13.4517C19.2669 13.0373 18.7876 12.4652 18.4536 11.7354C18.1196 11.0055 17.9526 10.1613 17.9526 9.20264V9.18408C17.9526 8.20068 18.1196 7.33789 18.4536 6.5957C18.7938 5.84733 19.2762 5.26595 19.9009 4.85156C20.5317 4.43099 21.2801 4.2207 22.146 4.2207C22.616 4.2207 23.0459 4.29492 23.4355 4.44336C23.8314 4.5918 24.1777 4.80208 24.4746 5.07422C24.7777 5.34635 25.0251 5.67415 25.2168 6.05762H25.3281V4.3877H27.6382V14.2495C27.6382 15.0226 27.4403 15.6937 27.0444 16.2627C26.6548 16.8317 26.0981 17.2708 25.3745 17.5801C24.6571 17.8955 23.8066 18.0532 22.8232 18.0532ZM22.814 12.2271C23.3459 12.2271 23.8005 12.1003 24.1777 11.8467C24.5612 11.5931 24.855 11.2406 25.0591 10.7891C25.2694 10.3314 25.3745 9.80257 25.3745 9.20264V9.18408C25.3745 8.58415 25.2694 8.05534 25.0591 7.59766C24.855 7.13379 24.5612 6.77507 24.1777 6.52148C23.8005 6.2679 23.3459 6.14111 22.814 6.14111C22.2882 6.14111 21.8368 6.2679 21.4595 6.52148C21.0884 6.77507 20.8039 7.1307 20.606 7.58838C20.408 8.04606 20.3091 8.57487 20.3091 9.1748V9.19336C20.3091 9.79948 20.408 10.3314 20.606 10.7891C20.8039 11.2406 21.0884 11.5931 21.4595 11.8467C21.8368 12.1003 22.2882 12.2271 22.814 12.2271ZM30.3657 14.5V4.3877H32.6758V5.93701H32.8242C33.0716 5.39274 33.4396 4.96598 33.9282 4.65674C34.4168 4.34749 35.026 4.19287 35.7559 4.19287C36.8877 4.19287 37.7505 4.52067 38.3442 5.17627C38.9442 5.83187 39.2441 6.7596 39.2441 7.95947V14.5H36.9341V8.48828C36.9341 7.70898 36.7671 7.12142 36.4331 6.72559C36.1053 6.32975 35.5951 6.13184 34.9023 6.13184C34.4447 6.13184 34.0488 6.23389 33.7148 6.43799C33.387 6.64209 33.1304 6.92969 32.9448 7.30078C32.7655 7.66569 32.6758 8.10173 32.6758 8.60889V14.5H30.3657ZM46.8701 14.5V4.3877H49.1802V14.5H46.8701ZM48.0298 2.71777C47.6587 2.71777 47.3371 2.5848 47.0649 2.31885C46.799 2.0529 46.666 1.73438 46.666 1.36328C46.666 0.986003 46.799 0.66748 47.0649 0.407715C47.3371 0.141764 47.6587 0.00878906 48.0298 0.00878906C48.4132 0.00878906 48.738 0.141764 49.0039 0.407715C49.2699 0.66748 49.4028 0.986003 49.4028 1.36328C49.4028 1.73438 49.2699 2.0529 49.0039 2.31885C48.738 2.5848 48.4132 2.71777 48.0298 2.71777ZM51.9448 14.5V4.3877H54.2549V5.93701H54.4033C54.6507 5.39274 55.0187 4.96598 55.5073 4.65674C55.9959 4.34749 56.6051 4.19287 57.335 4.19287C58.4668 4.19287 59.3296 4.52067 59.9233 5.17627C60.5233 5.83187 60.8232 6.7596 60.8232 7.95947V14.5H58.5132V8.48828C58.5132 7.70898 58.3462 7.12142 58.0122 6.72559C57.6844 6.32975 57.1742 6.13184 56.4814 6.13184C56.0238 6.13184 55.6279 6.23389 55.2939 6.43799C54.9661 6.64209 54.7095 6.92969 54.5239 7.30078C54.3446 7.66569 54.2549 8.10173 54.2549 8.60889V14.5H51.9448ZM70.3604 14.5L67.6143 4.3877H69.9336L71.6128 12.0044H71.7705L73.7188 4.3877H75.9175L77.875 12.0044H78.0234L79.7026 4.3877H81.9941L79.248 14.5H76.8359L74.8599 7.16162H74.7114L72.7446 14.5H70.3604ZM83.9424 14.5V4.3877H86.2524V14.5H83.9424ZM85.1021 2.71777C84.731 2.71777 84.4093 2.5848 84.1372 2.31885C83.8713 2.0529 83.7383 1.73438 83.7383 1.36328C83.7383 0.986003 83.8713 0.66748 84.1372 0.407715C84.4093 0.141764 84.731 0.00878906 85.1021 0.00878906C85.4855 0.00878906 85.8102 0.141764 86.0762 0.407715C86.3421 0.66748 86.4751 0.986003 86.4751 1.36328C86.4751 1.73438 86.3421 2.0529 86.0762 2.31885C85.8102 2.5848 85.4855 2.71777 85.1021 2.71777ZM92.9785 14.5649C91.8281 14.5649 90.9963 14.3516 90.4829 13.9248C89.9696 13.4919 89.7129 12.7868 89.7129 11.8096V6.17822H88.1636V4.3877H89.7129V1.90137H92.0601V4.3877H94.1753V6.17822H92.0601V11.29C92.0601 11.7972 92.1652 12.1652 92.3755 12.394C92.592 12.6167 92.9383 12.728 93.4146 12.728C93.5754 12.728 93.7083 12.7249 93.8135 12.7188C93.9248 12.7064 94.0454 12.694 94.1753 12.6816V14.4629C94.0145 14.4876 93.832 14.5093 93.6279 14.5278C93.4238 14.5526 93.2074 14.5649 92.9785 14.5649ZM96.5132 14.5V0.500488H98.8232V5.94629H98.9717C99.2129 5.40202 99.5778 4.97526 100.066 4.66602C100.561 4.35059 101.174 4.19287 101.903 4.19287C102.658 4.19287 103.292 4.34131 103.805 4.63818C104.325 4.93506 104.721 5.36491 104.993 5.92773C105.265 6.49056 105.401 7.17399 105.401 7.97803V14.5H103.091V8.50684C103.091 7.72135 102.924 7.1307 102.59 6.73486C102.256 6.33285 101.743 6.13184 101.05 6.13184C100.592 6.13184 100.196 6.23389 99.8623 6.43799C99.5283 6.64209 99.2716 6.92969 99.0923 7.30078C98.9129 7.66569 98.8232 8.10173 98.8232 8.60889V14.5H96.5132ZM112.266 14.5L117.025 1.11279H119.001V3.58984H118.296L114.771 14.5H112.266ZM114.66 11.0396L115.291 9.19336H121.423L122.054 11.0396H114.66ZM121.961 14.5L118.445 3.58984V1.11279H119.716L124.475 14.5H121.961ZM126.46 17.8584V4.3877H128.771V5.99268H128.919C129.104 5.6154 129.346 5.29688 129.643 5.03711C129.946 4.77734 130.295 4.57633 130.691 4.43408C131.087 4.29183 131.523 4.2207 131.999 4.2207C132.846 4.2207 133.579 4.43408 134.198 4.86084C134.822 5.2876 135.305 5.89062 135.645 6.66992C135.985 7.44303 136.155 8.36458 136.155 9.43457V9.45312C136.155 10.5293 135.985 11.457 135.645 12.2363C135.311 13.0156 134.832 13.6156 134.207 14.0361C133.589 14.4567 132.853 14.667 131.999 14.667C131.535 14.667 131.102 14.5959 130.7 14.4536C130.298 14.3052 129.946 14.098 129.643 13.832C129.34 13.5661 129.098 13.2507 128.919 12.8857H128.771V17.8584H126.46ZM131.275 12.728C131.801 12.728 132.253 12.5981 132.63 12.3384C133.007 12.0724 133.295 11.6951 133.493 11.2065C133.697 10.7118 133.799 10.1273 133.799 9.45312V9.43457C133.799 8.75423 133.697 8.16976 133.493 7.68115C133.295 7.19255 133.007 6.81836 132.63 6.55859C132.253 6.29883 131.801 6.16895 131.275 6.16895C130.762 6.16895 130.314 6.30192 129.93 6.56787C129.547 6.82764 129.253 7.20182 129.049 7.69043C128.845 8.17285 128.743 8.75423 128.743 9.43457V9.45312C128.743 10.1273 128.845 10.7087 129.049 11.1973C129.259 11.6859 129.553 12.0632 129.93 12.3291C130.314 12.5951 130.762 12.728 131.275 12.728ZM138.41 17.8584V4.3877H140.72V5.99268H140.868C141.054 5.6154 141.295 5.29688 141.592 5.03711C141.895 4.77734 142.244 4.57633 142.64 4.43408C143.036 4.29183 143.472 4.2207 143.948 4.2207C144.796 4.2207 145.528 4.43408 146.147 4.86084C146.772 5.2876 147.254 5.89062 147.594 6.66992C147.934 7.44303 148.104 8.36458 148.104 9.43457V9.45312C148.104 10.5293 147.934 11.457 147.594 12.2363C147.26 13.0156 146.781 13.6156 146.156 14.0361C145.538 14.4567 144.802 14.667 143.948 14.667C143.484 14.667 143.051 14.5959 142.649 14.4536C142.247 14.3052 141.895 14.098 141.592 13.832C141.289 13.5661 141.048 13.2507 140.868 12.8857H140.72V17.8584H138.41ZM143.225 12.728C143.75 12.728 144.202 12.5981 144.579 12.3384C144.956 12.0724 145.244 11.6951 145.442 11.2065C145.646 10.7118 145.748 10.1273 145.748 9.45312V9.43457C145.748 8.75423 145.646 8.16976 145.442 7.68115C145.244 7.19255 144.956 6.81836 144.579 6.55859C144.202 6.29883 143.75 6.16895 143.225 6.16895C142.711 6.16895 142.263 6.30192 141.879 6.56787C141.496 6.82764 141.202 7.20182 140.998 7.69043C140.794 8.17285 140.692 8.75423 140.692 9.43457V9.45312C140.692 10.1273 140.794 10.7087 140.998 11.1973C141.208 11.6859 141.502 12.0632 141.879 12.3291C142.263 12.5951 142.711 12.728 143.225 12.728ZM150.452 14.5V0.500488H152.762V14.5H150.452ZM159.933 14.7041C158.931 14.7041 158.068 14.4907 157.345 14.064C156.627 13.6372 156.074 13.0342 155.684 12.2549C155.294 11.4694 155.1 10.5417 155.1 9.47168V9.4624C155.1 8.3986 155.291 7.47396 155.675 6.68848C156.064 5.89681 156.615 5.28451 157.326 4.85156C158.037 4.41243 158.869 4.19287 159.822 4.19287C160.787 4.19287 161.615 4.40316 162.308 4.82373C163.007 5.2443 163.542 5.83496 163.913 6.5957C164.29 7.35645 164.479 8.24398 164.479 9.2583V10.019H156.259V8.479H163.356L162.252 9.92627V9.00781C162.252 8.33366 162.15 7.77702 161.946 7.33789C161.742 6.89258 161.461 6.55859 161.102 6.33594C160.743 6.11328 160.326 6.00195 159.85 6.00195C159.38 6.00195 158.959 6.11637 158.588 6.34521C158.223 6.57406 157.932 6.91423 157.716 7.36572C157.506 7.81104 157.4 8.3584 157.4 9.00781V9.92627C157.4 10.5509 157.506 11.0859 157.716 11.5312C157.926 11.9704 158.223 12.3075 158.606 12.5425C158.996 12.7775 159.454 12.895 159.979 12.895C160.394 12.895 160.75 12.8363 161.046 12.7188C161.343 12.5951 161.584 12.4466 161.77 12.2734C161.962 12.1003 162.092 11.9364 162.16 11.7817L162.197 11.7075H164.377L164.358 11.8003C164.278 12.1281 164.13 12.4621 163.913 12.8022C163.703 13.1424 163.415 13.4578 163.05 13.7485C162.692 14.033 162.252 14.265 161.733 14.4443C161.213 14.6175 160.613 14.7041 159.933 14.7041Z"
        fill="black"
      />
    </svg>
  );
};

export const RotateIcon = () => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.9571 1.29289C14.5666 0.902369 13.9334 0.902369 13.5429 1.29289C13.1524 1.68342 13.1524 2.31658 13.5429 2.70711L15.8358 5H12.25C7.83172 5 4.25 8.58172 4.25 13C4.25 17.4183 7.83172 21 12.25 21C16.6683 21 20.25 17.4183 20.25 13V11C20.25 10.4477 19.8023 10 19.25 10C18.6977 10 18.25 10.4477 18.25 11V13C18.25 16.3137 15.5637 19 12.25 19C8.93629 19 6.25 16.3137 6.25 13C6.25 9.68629 8.93629 7 12.25 7H15.8358L13.5429 9.29289C13.1524 9.68342 13.1524 10.3166 13.5429 10.7071C13.9334 11.0976 14.5666 11.0976 14.9571 10.7071L18.9571 6.70711L19.6642 6L18.9571 5.29289L14.9571 1.29289Z"
        fill="black"
      />
    </svg>
  );
};

export const SearchLeftBtnIcon = () => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
      <rect x="2" y="2" width="36" height="36" rx="18" fill="white" />
      <path
        d="M22.5 25L17.5 20L22.5 15"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const SearchRightBtnIcon = () => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
      <rect x="2" y="2" width="36" height="36" rx="18" fill="white" />
      <path
        d="M17.5 25L22.5 20L17.5 15"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const ArrowDownIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7066 19.7076L12 20.4142L11.2929 19.7071L5.29289 13.7071C4.90237 13.3166 4.90237 12.6834 5.29289 12.2929C5.68342 11.9024 6.31658 11.9024 6.70711 12.2929L11 16.5858L11 5C11 4.44771 11.4477 4 12 4C12.5523 4 13 4.44771 13 5L13 16.5858L17.2929 12.2929C17.6834 11.9024 18.3166 11.9024 18.7071 12.2929C19.0976 12.6834 19.0976 13.3166 18.7071 13.7071L12.7077 19.7065L12.7071 19.7071L12.7066 19.7076Z"
        fill="#4683FB"
      />
    </svg>
  );
};

export const ArrowUpIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.2929 11.7073C17.6834 12.0978 18.3166 12.0978 18.7071 11.7073C19.0976 11.3167 19.0976 10.6836 18.7071 10.293L12.7071 4.29304L12 3.58594L11.2937 4.29225C11.2932 4.29277 11.2926 4.2933 11.2921 4.29382L5.29289 10.293C4.90237 10.6836 4.90237 11.3167 5.29289 11.7073C5.68342 12.0978 6.31658 12.0978 6.70711 11.7073L11 7.41437L11 19.0002C11 19.5524 11.4477 20.0002 12 20.0002C12.5523 20.0002 13 19.5524 13 19.0002L13 7.41436L17.2929 11.7073Z"
        fill="#F1414A"
      />
    </svg>
  );
};

export const AudioPlayIcon = () => {
  return (
    <svg width="41" height="40" viewBox="0 0 41 40" fill="none">
      <path
        d="M20.4987 36.6663C29.7034 36.6663 37.1654 29.2044 37.1654 19.9997C37.1654 10.7949 29.7034 3.33301 20.4987 3.33301C11.294 3.33301 3.83203 10.7949 3.83203 19.9997C3.83203 29.2044 11.294 36.6663 20.4987 36.6663Z"
        stroke="#242629"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.1654 13.333L27.1654 19.9997L17.1654 26.6663V13.333Z"
        stroke="#242629"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
